import { api, plainApi } from "./client";

export interface DemoWindowInput {
  start_at: string;
  end_at: string;
}

export interface DemoInviteRecord {
  id: string;
  email: string;
  status: string;
  orgId: string;
  orgName?: string | null;
  createdAt?: string | null;
  acceptedAt?: string | null;
  inviteExpiresAt?: string | null;
  windows?: Array<{ id: string; startAt: string; endAt: string }>;
}

export const demoInviteService = {
  async list(params?: { status?: string; email?: string }): Promise<DemoInviteRecord[]> {
    const response = await api.get<{ demoInvites: DemoInviteRecord[] }>("/demo_invites", {
      params,
    });
    return response.data.demoInvites ?? [];
  },

  async create(payload: {
    email: string;
    org_name: string;
    max_seats?: number | null;
    max_sops?: number | null;
    max_upload_bytes?: number | null;
    windows: DemoWindowInput[];
    features: Record<string, boolean>;
    invite_expires_at?: string | null;
  }) {
    const response = await api.post("/demo_invites", payload);
    return response.data;
  },

  async revoke(id: string) {
    const response = await api.delete(`/demo_invites/${id}`);
    return response.data;
  },

  async replaceWindows(id: string, windows: DemoWindowInput[]) {
    const response = await api.patch(`/demo_invites/${id}/windows`, { windows });
    return response.data;
  },

  async accept(payload: { token: string; email: string }) {
    const response = await plainApi.post("/demo_invites/accept", payload);
    return response.data as { org_id: string; login_url: string };
  },
};
